import { createWebHistory, createRouter } from "vue-router";

import Start    from "./views/Start.vue";
import Checkout from "./views/Checkout.vue";
import Products from "./views/Products.vue";
import Contact  from "./views/Contact.vue";
import NotFound from "./views/NotFound.vue";

const routes = [
  { name: "Start",    component: Start,    path: "/",           },
  { name: "Checkout", component: Checkout, path: "/checkout",   },
  { name: "Products", component: Products, path: "/products",   },
  { name: "Contact",  component: Contact,  path: "/contact-us", },
  { name: "404",      component: NotFound, path: "/:catchAll(.*)", },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (to.hash) {
                return {
                    el: to.hash
                }
            }
        }
        return { top: 0 }
    }
});

// TODO: Add middleware for login

export default router;
